import { RootState } from '../store';

export const selectPageState = (state: RootState): any => state.pageState;
